import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('UTC')

export const isMatchingMessage = (messages: string[], prefix: string) => {
  return messages.length > 1 && messages[0] === prefix
}

export const isSameCandle = (
  newTimestamp: number,
  previousTimestamp: number,
  klineType: number, // klineType: minutes (1, 3, 5, 15, 30, 60, etc.)
): boolean => {
  const previousDate = new Date(previousTimestamp)
  const previousYear = previousDate.getFullYear()
  const previousMonth = previousDate.getMonth()
  const previousDay = previousDate.getDate()
  const previousHour = previousDate.getHours()
  const previousMinute = previousDate.getMinutes()

  // 计算精确到分钟的时间戳
  const minuteBasedTimestamp = new Date(
    previousYear,
    previousMonth,
    previousDay,
    previousHour,
    previousMinute,
  ).getTime()

  // 计算结束时间
  const endDate = new Date(minuteBasedTimestamp)

  // 根据klineType调整结束时间
  if (klineType < 60) {
    // 小于60分钟，直接用setMinutes增加
    endDate.setMinutes(endDate.getMinutes() + klineType)
  } else if (klineType < 1440) {
    // 小于一天，按小时处理
    endDate.setHours(endDate.getHours() + Math.floor(klineType / 60))
    endDate.setMinutes(endDate.getMinutes() + (klineType % 60))
  } else if (klineType === 1440) {
    // 日线，按天数处理
    endDate.setDate(endDate.getDate() + 1)
  } else if (klineType === 10080) {
    // 周线，按周数处理
    endDate.setDate(endDate.getDate() + 7)
  } else if (klineType === 43200) {
    // 月线，按月数处理
    endDate.setMonth(endDate.getMonth() + 1)
  }

  // 判断newTimestamp是否在previousTimestamp和endTimestamp之间
  return newTimestamp >= minuteBasedTimestamp && newTimestamp <= endDate.getTime()
}

/**
 * 秒数转时分秒格式
 * @param {number} totalSeconds - 总秒数
 * @returns {string} - 格式化后的字符串 HH:mm:ss
 */
export const formatSeconds = (totalSeconds: number | string) => {
  if (typeof totalSeconds === 'string') {
    totalSeconds = Number(totalSeconds)
  }
  if (isNaN(totalSeconds)) {
    return '00:00:00'
  }
  const d = dayjs.duration(totalSeconds, 'seconds')
  const hours = String(d.hours() + d.days() * 24).padStart(2, '0') // 支持超过24小时
  const minutes = String(d.minutes()).padStart(2, '0')
  const seconds = String(d.seconds()).padStart(2, '0')
  return `${hours}:${minutes}:${seconds}`
}

// 转成年/月/日 时:分：秒 以UTC 0时区来转换
export function toUTC(date: string | number | Date) {
  return dayjs.utc(date).format('YYYY/MM/DD HH:mm:ss')
}

// 10位时间戳 以机器时区 转 年/月/日 时:分：秒
export function toLocal(timestamp: number) {
  // 如果timestamp是字符串日期时间 直接返回
  if (typeof timestamp === 'string') {
    return timestamp
  }
  if (timestamp < 10) {
    return '--'
  }
  return dayjs.unix(timestamp).format('YYYY/MM/DD HH:mm:ss')
}

// 10位时间戳 以机器时区 转 年/月/日 时:分：秒
export function toLocalDay(timestamp: number) {
  // 如果timestamp是字符串日期时间 直接返回
  if (typeof timestamp === 'string') {
    return timestamp
  }
  if (timestamp < 10) {
    return '--'
  }
  return dayjs.unix(timestamp).format('YYYY/MM/DD')
}
// 10位时间戳 以机器时区 转 年/月/日 时:分：秒
export function toLocalDayBar(timestamp: number) {
  if (typeof timestamp === 'string') {
    return timestamp
  }
  if (timestamp < 10) {
    return '--'
  }
  return dayjs.unix(timestamp).format('YYYY-MM-DD')
}

// 10位时间戳 以机器时区 获取 月
export function getMonthFromTimestamp(timestamp: number) {
  if (typeof timestamp === 'string') {
    return timestamp
  }
  if (timestamp < 10) {
    return '--'
  }
  return dayjs.unix(timestamp).format('MM')
}
